/**
 * Carga `path` de cero (recarga completa), NO una navegación dentro de la SPA.
 *
 * Se usa después de canjear un código de acceso: `PsychologistContext` solo restaura sus datos al montarse, así
 * que cambiar la sesión "en caliente" dejaría en memoria a la psicóloga anterior (nombre, caché de pacientes).
 * Recargar remonta todo con la sesión nueva. Vive aparte para poder mockearlo en los tests (jsdom no navega).
 */
export function hardNavigate(path: string): void {
  window.location.replace(path);
}
